import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  FullName,
  GrantTerm,
  GrantedArea,
  KSANCardNumberIssued,
  MEDIUM_ITEM_SIZE,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityCardsToExternalEntitiesLongTermRenewTemplate = {
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  unit: string;
  KSANCardNumberIssued: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityCardsToExternalEntitiesLongTermRenewTemplate: TemplatesValue<SecurityCardsToExternalEntitiesLongTermRenewTemplate> =
  {
    fileName: "DanhSachNhanVienDaiHanCapLai",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...FullName,
        itemSize: MEDIUM_ITEM_SIZE,
      },
      Sex,
      PersonalId,
      Regency,
      {
        ...Team,
        header: "Đơn vị",
      },
      KSANCardNumberIssued,
      GrantTerm,
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: [
      "name",
      "sex",
      "personalId",
      "regency",
      "unit",
      "KSANCardNumberIssued",
      "grantTerm",
      "grantedArea",
      "note",
    ],
  };
